<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
      <v-toolbar-title>Información de la cuenta</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="logOut">
        <v-icon color="red darken-1">mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="list-of-content" v-if="profile.length > 0">
      <v-list three-line>
        <template>
          <v-list-item v-if="profile.length > 0">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title">Información de la cuenta</v-list-item-title>
              <!-- <v-list-item-subtitle v-html="item.content"></v-list-item-subtitle> -->
              <table class="list-of-content__details">
                <tr v-if="profile[0].codigo!=''">
                  <th>Codigo</th>
                  <td>{{profile[0].codigo}}</td>
                </tr>
                <tr v-if="profile[0].nombre!=''">
                  <th>Nombre</th>
                  <td>{{profile[0].nombre}}</td>
                </tr>
                <tr v-if="profile[0].descripcion_oficina!=''">
                  <th>Oficina</th>
                  <td>{{profile[0].descripcion_oficina}}</td>
                </tr>
                <tr v-if="profile[0].sector!=''">
                  <th>Sector</th>
                  <td>{{profile[0].sector}}</td>
                </tr>
                <tr v-if="profile[0].direccion_oficina!=''">
                  <th>Dirección de la oficina</th>
                  <td>{{profile[0].direccion_oficina}}</td>
                </tr>
                <tr v-if="profile[0].email_address_oficina!=''">
                  <th>Email</th>
                  <td>{{profile[0].email_address_oficina}}</td>
                </tr>
                <tr v-if="profile[0].telefono1_oficina!=''">
                  <th>Teléfono 1</th>
                  <td>{{profile[0].telefono1_oficina}}</td>
                </tr>
                <tr v-if="profile[0].telefono2_oficina!=''">
                  <th>Teléfono 2</th>
                  <td>{{profile[0].telefono2_oficina}}</td>
                </tr>
                <tr v-if="profile[0].instagram!=''">
                  <th>Instagram</th>
                  <td>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="openUrl('https://www.instagram.com/'+profile[0].instagram)"
                    >{{profile[0].instagram}}</v-btn>
                  </td>
                </tr>
                <tr v-if="profile[0].facebook!=''">
                  <th>Facebook</th>
                  <td>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="openUrl('https://www.facebook.com/'+profile[0].facebook)"
                    >{{profile[0].facebook}}</v-btn>
                  </td>
                </tr>
                <tr v-if="profile[0].twiiter!=''">
                  <th>Twitter</th>
                  <td>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="openUrl('https://twitter.com/'+profile[0].twiiter)"
                    >{{profile[0].twiiter}}</v-btn>
                  </td>
                </tr>
                <tr v-if="profile[0].website!=''">
                  <th>Website</th>
                  <td>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="openUrl(profile[0].website)"
                    >{{profile[0].website}}</v-btn>
                  </td>
                </tr>

                <tr>
                  <td colspan="2">
                    <v-btn
                      color="info"
                      class="mb-3 mt-1"
                      block
                      v-if="profile[0].longitud !=='' && profile[0].latitud !==''"
                      @click="openMap(profile[0].longitud,profile[0].latitud,profile[0].descripcion_oficina)"
                    >Ver en el mapa</v-btn>
                  </td>
                </tr>

                <tr v-if="currentUser">
                  <th>QR Code</th>
                  <td>
                    <v-img
                      max-width="200"
                      :src="'http://mdev7.onecontrolcargosystem.com/qrcode.php?'+'text1='+currentUser.userName+'&text3='+currentUser.pushId"
                    ></v-img>
                  </td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="profile.length > 0">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title">Dirección Miami</v-list-item-title>
              <!-- <v-list-item-subtitle v-html="item.content"></v-list-item-subtitle> -->
              <table class="list-of-content__details">
                <tr v-if="profile[1].DIRECCION_FULL!=''">
                  <th>Full address</th>
                  <td>{{profile[1].DIRECCION_FULL}}</td>
                </tr>
                <tr v-if="profile[1].address1!=''">
                  <th>Address 1</th>
                  <td>{{profile[1].address1}}</td>
                </tr>
                <tr v-if="profile[1].address2!=''">
                  <th>Address 2</th>
                  <td>{{profile[1].address2}}</td>
                </tr>
                <tr v-if="profile[1].city !=''">
                  <th>City</th>
                  <td>{{profile[1].city}}</td>
                </tr>
                <tr v-if="profile[1].state !=''">
                  <th>State</th>
                  <td>{{profile[1].state}}</td>
                </tr>
                <tr v-if="profile[1].telefono_direccion!=''">
                  <th>Telefono</th>
                  <td>{{profile[1].telefono_direccion}}</td>
                </tr>
                <tr v-if="profile[1].zipcode !=''">
                  <th>Zipcode</th>
                  <td>{{profile[1].zipcode}}</td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <div class="pl-3 pr-3 pb-5 pt-4">
        <v-btn color="error" @click="logOut" large block>Salir</v-btn>
      </div>
    </div>
    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">NO TIENES DATOS DISPONIBLES</div>
      </div>
      <v-progress-circular :size="90" color="blue" v-else indeterminate class="loading-center"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      currentUser: undefined,
    };
  },
  computed: {
    noData() {
      return this.profile.length > 0 ? true : false;
    },
    login: function () {
      return this.$store.getters.login;
    },
    user: function () {
      return this.$store.getters.user;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
  },
  methods: {
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    openUrl(url) {
      window.MobileApi.openUrl(url);
    },
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);

      this.$store.dispatch("getProfile", {
        Vue: this,
        url: Server.profile,
        data: formData,
      });
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
